import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_23 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_24 = { class: "indicator-label" }
const _hoisted_25 = { class: "indicator-progress" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'ive'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewIveValue')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.areaSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedArea,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedArea) = $event)),
                      requierd: true,
                      label: "title",
                      trackBy: "title",
                      searchable: true,
                      canDeselect: false,
                      options: _ctx.areas,
                      placeholder: _ctx.translate('selectAreas'),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound')
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('value')), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "price",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('price')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_ErrorMessage, { name: "price" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('isSeaView')) + ": ", 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isSeaView",
                        type: "checkbox",
                        value: true,
                        checked: "checked"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.translate('customUpdatedAt')) + ": ", 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "customUpdatedAt",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_25, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_26
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}